// currencies.js
export const currencies = [
  { value: "PKR", label: "Pakistani Rupee (PKR)" },
  { value: "ILS", label: "Palestine New Shekel (ILS)" },  
  { value: "JOD", label: "Jordanian Dinar (JOD)" },
  { value: "BDT", label: "Bangladeshi Taka (BDT)" },
  { value: "INR", label: "Indian Rupee (INR)" },
  { value: "AFN", label: "Afghan Afghani (AFN)" },
  { value: "YER", label: "Yemeni Rial (YER)" },
  { value: "SYP", label: "Syrian Pound (SYP)" },
  { value: "IRR", label: "Iranian Rial (IRR)" },
  { value: "IQD", label: "Iraqi Dinar (IQD)" },
  { value: "LBP", label: "Lebanese Pound (LBP)" },
  { value: "EGP", label: "Egyptian Pound (EGP)" },
  { value: "SDG", label: "Sudanese Pound (SDG)" },
  { value: "TRY", label: "Turkish Lira (TRY)" },
  { value: "USD", label: "US Dollar (USD)" },
];

export default currencies;